import React from "react";

const Footer = (props) => {
  return (
    <footer className="footer-custom bg-black-custom position-fixed bottom-0">
      <div className="container">
        <span className="text-light">
          &copy; 2016-2024 firmconnector.com. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
